import React, { useState, useEffect, useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

const ShareTicketModal = ({ modalOpen, onClose, ticketId }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user: loggedInUser } = useContext(AuthContext);

  const [initialValues, setInitialValues] = useState({ users: [] });

  useEffect(() => {
    if (!modalOpen) {
      setInitialValues({ users: [] });
      setOptions([]);
      return;
    }
    
    const fetchInitialUsersAndOptions = async () => {
      setLoading(true);
      try {
        const { data: ticketData } = await api.get(`/tickets/${ticketId}`);
        const sharedUsers = ticketData.sharedWithUsers || [];
        
        setInitialValues({ users: sharedUsers });

        const { data: allUsersData } = await api.get("/users/");
        
        const usersToExclude = new Set([loggedInUser.id, ticketData.userId]);
        setOptions(allUsersData.users.filter(u => !usersToExclude.has(u.id)));

      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    };

    fetchInitialUsersAndOptions();
  }, [modalOpen, ticketId, loggedInUser.id]);

  const handleClose = () => {
    onClose();
  };

  const handleSave = async (values) => {
    setLoading(true);
    try {
      const userIds = values.users.map(u => u.id);
      await api.post(`/tickets/${ticketId}/share`, { userIds });
      toast.success("Ticket compartido exitosamente");
      handleClose();
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };
  
  return (
    <Dialog open={modalOpen} onClose={handleClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>Compartir Ticket #{ticketId}</DialogTitle>
      
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <CircularProgress />
        </div>
      ) : (
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          onSubmit={(values) => handleSave(values)}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <DialogContent dividers>
                  <Autocomplete
                    multiple
                    options={options}
                    value={values.users}
                    onChange={(e, newUsers) => {
                      setFieldValue("users", newUsers);
                    }}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option, value) => option.id === value.id}
                    noOptionsText="No hay usuarios para mostrar"
                    loadingText="Cargando..."
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccionar usuarios"
                        variant="outlined"
                        placeholder="Busca por nombre..."
                      />
                    )}
                  />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="secondary" variant="outlined" disabled={loading}>
                  {i18n.t("transferTicketModal.buttons.cancel")}
                </Button>
                <Button type="submit" color="primary" variant="contained" disabled={loading}>
                  Guardar
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};

export default ShareTicketModal;